export default __webpack_public_path__ + "static/media/header_logo.34e5569e.svg";